document.addEventListener("alpine:init", () => {
  const contentMap = {
    step1HTML: ".app-content.find-course-by-atar-step-1",
    adjustmentPointsFootnoteHTML:
      ".app-content.find-course-by-atar-adjustment-points-footnote",
  };

  const appContent = {};
  Object.keys(contentMap).forEach(
    (k) =>
      (appContent[k] = document.querySelector(contentMap[k])
        ? document.querySelector(contentMap[k]).innerHTML
        : "")
  );

  Alpine.data("estimateATARScoreSlider", () => ({
    appContent,

    showAdjustmentPoints: false,

    init() {
      this.$nextTick(() => {
        if (!!Alpine.store("atarCalculator").adjustmentPoints) {
          this.showAdjustmentPoints = true;
        }
        this.adjustATAR();
      });
    },

    adjustATAR() {
      const atarValue = Alpine.store("atarCalculator").adjustedATAR;
      const adjustmentPoints = isNaN(
        Alpine.store("atarCalculator").adjustmentPoints
      )
        ? 0
        : parseInt(Alpine.store("atarCalculator").adjustmentPoints, 10);

      if (adjustmentPoints) {
        (async () => {
          const rawResponse = await fetch(
            "/atar/wizard/api/calculator/calculate-adjusted",
            {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                atar: atarValue,
                adjustmentPoints: adjustmentPoints,
              }),
            }
          );
          const data = await rawResponse.json();

          Alpine.store("atarCalculator").estimateAdjustedATAR = parseFloat(
            data.adjustedATAR
          );
          Alpine.store("atarCalculator").adjustmentPoints =
            data.adjustmentPoints;
        })();
      } else {
        Alpine.store("atarCalculator").estimateAdjustedATAR = atarValue;
      }
    },
  }));
});
